import React from "react";
import { useNavigate } from "react-router-dom";
import "./CTA.css";

const CTASection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact"); // Navigate to Contact page
  };

  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>Ready to Find Your Perfect Property?</h2>
        <p>Connect with us today and experience hassle-free property buying with Sai Bhavana Realty.</p>
        <button className="cta-button" onClick={handleClick}>
          Contact Us <span className="cta-icon">→</span>
        </button>
      </div>
    </section>
  );
};

export default CTASection;